import { Badge } from '@mantine/core';
import classes from './Badge.module.css';

export const BadgeConfig = Badge.extend({
  classNames: {
    root: classes.root,
  },
});
